import { render, staticRenderFns } from "./addNoticeViewList.vue?vue&type=template&id=73cb736b&scoped=true"
import script from "./addNoticeViewList.vue?vue&type=script&lang=js"
export * from "./addNoticeViewList.vue?vue&type=script&lang=js"
import style0 from "./addNoticeViewList.vue?vue&type=style&index=0&id=73cb736b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cb736b",
  null
  
)

export default component.exports